const MailIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={"1em"}
        height={"1em"}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.00002 6.66667L8.15102 8.76733C9.27069 9.51378 10.7294 9.51378 11.849 8.76733L15 6.66667M5.00002 17.5H15C16.841 17.5 18.3334 16.0076 18.3334 14.1667V5.83333C18.3334 3.99238 16.841 2.5 15 2.5H5.00002C3.15907 2.5 1.66669 3.99238 1.66669 5.83333V14.1667C1.66669 16.0076 3.15907 17.5 5.00002 17.5Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default MailIcon;
